export default __webpack_public_path__ + "static/nine-7e8f8763cfedc468944b3cef19081af5.jpg";